@if (query) {
  <p class="hc-query">Results for “{{ query }}”</p>
}

@if (loading) {
  <div class="hc-loading">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
  </div>
}

@if (!loading && searched && results.length === 0) {
  <p>No articles matched your search.</p>
}

@if (!loading && results.length > 0) {
  <div class="hc-list-card">
    @for (article of results; track article.slug) {
      <button type="button" class="hc-row" (click)="openArticle.emit(article.slug)">
        <span class="hc-row-title">
          {{ article.title }}
          @if (article.category) {
            <span class="hc-row-cat"> — {{ article.category }}</span>
          }
        </span>
        <mat-icon>chevron_right</mat-icon>
      </button>
    }
  </div>
}
